export function formatUtcDate(
  value: string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
) {
  return new Intl.DateTimeFormat('en-US', {
    ...options,
    timeZone: 'UTC',
  }).format(new Date(value));
}

export function formatUtcDateTime(value: string) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'UTC',
  }).format(new Date(value));
}

export function formatRelativeSsrDate(value: string, referenceValue?: string | null) {
  const date = new Date(value);
  const referenceDate = referenceValue ? new Date(referenceValue) : new Date();
  const diffInHours = Math.max(0, Math.floor((referenceDate.getTime() - date.getTime()) / (1000 * 60 * 60)));

  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
  }

  return formatUtcDate(value, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
